import { html } from 'lit';

export const renderBlurb = (policyUrl: string) => html`
  <p>
    This site, Global Portal, uses cookies to enhance user experience and
    analyze performance and traffic on the website. We share information about
    your use of the portal with our analytics partner. Please, click on the
    <a
      href="${policyUrl}"
      target="_blank"
      data-test-id="cookie-policy-link"
      class="text-on-surface-primary underline"
      >Cookies Policy</a
    >
    link to review it and continue with your preference selection.
  </p>
`;
